import React from "react"
import {FormControl, FormErrorMessage, FormLabel, Switch} from "@chakra-ui/react"

import {IInputFormProps} from "./interfaces"

export function FSwitch(props: IInputFormProps & { value?: boolean }) {
    const {
        field,
        label,
        rules,
        initialValue,
        register,
        errors,
        value,
        className,
    } = props
    console.log("watchreason", value)
    return <FormControl isInvalid={errors[field]} className={className} display="flex" alignItems="center"
                        justifyContent="space-between">
        <FormLabel m={0} htmlFor={field}>{label}</FormLabel>
        <Switch id={field} defaultChecked={initialValue}
                isChecked={value}
                {...register(field, rules)}
        />
        <FormErrorMessage>
            {errors[field] && errors[field].message}
        </FormErrorMessage>
    </FormControl>
}